import React, { useState, useMemo, useEffect, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import Popover from './Popover';
import DateSelector from '../Shared/DateSelector';
import DefaultDataTable from '../Shared/DefaultDataTable';
import ConfirmReason from "../ConfirmReason";
import Confirm from "../Confirm";
import Selector from '../Selector';
import Checkbox from "@material-ui/core/Checkbox";
import useStyles from './styles';
import { SchedulingStatus } from '../../api/scheduling';
import { usePermissions } from '../../utils/permissions';
import { useFunctionInterval } from '../../utils';
import { downloadResume } from '../../api/scheduling';
import { setDataStorage, filterInputValue, getDataStorage, removeDataStorage } from '../../utils/filterManagementDataStore';
import ModalBarcode from './Modal/Barcode';
import ModalCalled from './Modal/Called';
import ModalEdit from './ModalEdit';
import IconClear from '@material-ui/icons/Clear';
import InputAdornment from '@material-ui/core/InputAdornment';
import { SchedulingColumnSelector } from '../SchedulingColumnSelector';
import BlockIcon from '@material-ui/icons/Block';
import CheckIcon from '@material-ui/icons/CheckCircleOutline';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const SchedulingComponent = ({
  subRoutes,
  filter,
  setFilter,
  branches,
  plants,
  onNewScheduling,
  onCancelScheduling,
  onCalled,
  onTransit,
  onCallSeveralScheduling,
  onUpdateScheduling,
  schedulings,
  searchBarcode,
  barcodeScheduling,
  onConfirmBarcode,
  setAdditionalInfoCalled,
  getDriver,
  clients,
  currentTab,
  setTab,
  enableCalled,
  enableSendTruck,
  tabsOrdered,
  setMonitorOpened,
  getStatus,
  getCallMessages,
  schedulingTableColumns,
  item,
  setItem,
  targetPopover,
  setTargetPopover,
  columnsConfig,
  concatToSchedulingTableColumns,
  updateSchedulingConfigColumnVisibility,
  changeSchedulingTableColumnVisibility,
  addSchedulingTableColumns,
  hideDirector
}) => {
  const classes = useStyles();
  const [isOpenConfirm, setOpenConfirm] = useState(false);
  const [isOpenModalBarcode, setOpenModalBarcode] = useState(false);
  const [isOpenModalCalled, setOpenModalCalled] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [currentModal, setCurrentModal] = useState('cancel');
  const { scheduling: schedulingPermissions } = usePermissions();
  const [ showOptionPendings, setShowOptionPendings ] = useState(false);

  const handleSelectFilterChange = (selected, keyFilter) => {
    setFilter({
      ...filter,
      [keyFilter]: selected?.value ? selected.value : selected,
    });
  };

  const handleSelectFilterDate = (date, shouldGetPendings) => {
    setFilter({
      ...filter,
      schedulingDate: date?.value ? date.value : date,
      shouldGetPendings
    });
  };

  const handleOpenEdit = () => {
    setEditItem({...item});
    setTargetPopover(null);
    setItem(null);
  }

  const handleRescheduling = () => {
    window.location.href = window.origin ===
    'http://localhost:3000'
    ? `http://localhost:3001/rescheduling/single/${item.id}`
    : `${window.origin}/peach/rescheduling/single/${item.id}`
  }


  const IconOrButton = item => {
    const switchIcon = item => {
      switch (item.scheduling_status) {
        case SchedulingStatus.canceled:
          return <BlockIcon className={classes.iconCanceled} />;
        case SchedulingStatus.completed:
          return <CheckIcon className={classes.iconCompleted} />;
        default:
          return schedulingPermissions.canCancel && (
            <IconButton
              onClick={handlePopoverVisible(item)}
            >
              <MoreVertIcon />
            </IconButton>
          );
      }
    };

    return <>{switchIcon(item)}</>;
  };

  const handlePopoverVisible = item => (
    e => {
      setItem(item);
      setTargetPopover(e.target);
    }
  );

  const filterDate = useCallback(() => {
    if (filter.schedulingDate) {
      return filter.schedulingDate;
    }

    return getDataStorage('scheduling_date');
  }, [filter.schedulingDate]);

  useEffect(() => {
    const date = filterDate();

    if (date) {
      setShowOptionPendings(moment(new Date(), 'YYYY-MM-DD').isSame(date, 'day'));
    }

  }, [filter.schedulingDate, filterDate]);

  useEffect(() => {
    if (filter.schedulingDate && clients.length === 0) {
      removeDataStorage('scheduling_client');
    }

  }, [filter.schedulingDate, clients]);

  useEffect(() => {
    const schedulingBranches = getDataStorage('scheduling_branches');
    const schedulingPlants = getDataStorage('scheduling_plants');
    if ((filter.branches || schedulingBranches) && schedulingPlants) {
      const filteredPlants = schedulingPlants.filter((plant) => {
        return schedulingBranches.some((branch) => branch.value === plant.branchId);
      });
      setDataStorage('scheduling_plants', filteredPlants);
    } else {
      removeDataStorage('scheduling_plants');
    }
  }, [plants, filter.branches]);

  useEffect(() => {
    if (columnsConfig) {
      concatToSchedulingTableColumns({
        name: <SchedulingColumnSelector
                changeSchedulingTableColumnVisibility={changeSchedulingTableColumnVisibility}
                updateSchedulingConfigColumnVisibility={updateSchedulingConfigColumnVisibility}
                columnsConfig={columnsConfig}
                currentTab={currentTab}
                >
                </SchedulingColumnSelector>,
        key: 'columnSelectorComponent',
        maxWidth: '30px',
        cell: row => <IconOrButton {...row} />,
      });
    }
  }, [
      columnsConfig,
      concatToSchedulingTableColumns,
      changeSchedulingTableColumnVisibility,
      currentTab,
      updateSchedulingConfigColumnVisibility,
      schedulingTableColumns,
      hideDirector
    ]);



  const modalConfirm = useMemo(() => ({
    cancel: {
      title: 'Confirma cancelamento deste agendamento?',
      description: 'Motivo do cancelamento (obrigatório)',
      onCloseCallback: onCancelScheduling
    },
    call: {
      title: 'Confirma chamado?',
      onCloseCallback: onCalled
    },
    transit: {
      title: 'Confirma o envio?',
      onCloseCallback: onTransit
    }
  }), [onCancelScheduling, onCalled, onTransit]);

  const handleConfig = (promise) => {
    return async (confirm, value) => {
      if (confirm) {
        setTargetPopover(null);
        await promise(item.id, value);
        setItem(null);
      }
      setOpenConfirm(false);
    };
  };

  const handlePopoverClose = _ => {
    setTargetPopover(null);
    setItem(null);
  };

  const handlePrintPDF = _ => {
    setTargetPopover(null);
    downloadResume(item.id);
    setItem(null);
  };

  const handleOpenConfirm =  (modal) => {
    setTargetPopover(null);
    setOpenConfirm(true);
    setCurrentModal(modal);
  }

  const handleMonitorOpen = () => {
    setTargetPopover(null);
    setItem(item);
    getStatus(item.id);
    getCallMessages(item.id);
    setMonitorOpened(true);

  }

  const cantCancell = () => item &&
      !([
        SchedulingStatus.scheduled,
        SchedulingStatus.rescheduled,
        SchedulingStatus.delayed,
        SchedulingStatus.inLine,
        SchedulingStatus.inProgress,
      ].indexOf(item.scheduling_status) !== -1
      );

    const cantCall = () => item &&
      !([SchedulingStatus.inLine].includes(item.scheduling_status));

    const cantCallAgain = () => item &&
      !([SchedulingStatus.called].includes(item.scheduling_status));

  const canEdit = () => currentTab === 0 && !!item && item.plant_allow_editing;

  const canShowRescheduling = () =>  {
    const { user } = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : null
    return currentTab === 0 || (user?.groups?.includes('backoffice') && currentTab === 1) || (user?.groups?.includes('backoffice') && currentTab === 2)
   }

  const canRescheduling = () =>  {
   return (currentTab === 0 || currentTab === 1 || currentTab === 2) && item?.is_reschedule
  }

   const cantTransit = () => item &&
      !([
        SchedulingStatus.called,
      ].indexOf(item.scheduling_status) !== -1
      );

  const renderConfirm = (modalConfirmItem) => {
    const confirms = {
      reason: ConfirmReason,
      main: Confirm
    };

    let confirm = 'reason';
    let propsExtras = { placeholder: modalConfirmItem.description };

    if (typeof modalConfirmItem.description === 'undefined') {
      confirm = 'main';
      propsExtras = { message: "" };
    }

    const ConfirmCmp = confirms[confirm];

    return (
      <ConfirmCmp
        isOpen={isOpenConfirm}
        title={modalConfirmItem.title}
        okText="Sim"
        cancelText="Não"
        handleClose={handleConfig(modalConfirmItem.onCloseCallback)}
        {...propsExtras}
      />
    );
  };

  const noDataMessage = () => {
    if (!filterDate()) {
      return 'Por favor, selecione uma data.';
    }

    if (!getDataStorage('scheduling_branches')) {
      return 'Por favor, selecione uma filial.';
    }

    return 'Não existem dados a serem apresentados.';
  };

  const a11yProps = index => ({
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  });

  const handleChangeTab = (_, tab) => setTab(tab);

  const isTabMatchSchedulingStatus = (tab, status) => tabsOrdered.indexOf(status) === tab;

  const handleSearchTruckPlate = useFunctionInterval((truckPlate) => {
    handleSelectFilterChange(truckPlate, 'truckPlate');
  }, 1000);

  const handleWithColumnAndValues = (columns = [], tab) => {
    return columns
  }

  const handleWithTabsAndTitles = (columns = [], tab) => {
    if (!isTabMatchSchedulingStatus(tab, SchedulingStatus.all)
      && !isTabMatchSchedulingStatus(tab, SchedulingStatus.scheduled)
      && !isTabMatchSchedulingStatus(tab, SchedulingStatus.called)
    ) {
      return columns.filter(item => item.selector !== 'scheduling_status');
    }

    return columns
  }

  const getRowConditionsByTabIndex = (tabIndex) =>{
      let rowConditions = {};
      const tab = tabsOrdered[tabIndex];

      switch(tab){

         case SchedulingStatus.scheduled:
            rowConditions = {
              [SchedulingStatus.delayed]: {
                  when: row => row.scheduling_status === SchedulingStatus.delayed,
                  style:{
                  color : 'red !important'
               }},
              [SchedulingStatus.rescheduled]: {
                when: row => row.scheduling_status === SchedulingStatus.rescheduled,
                style:{
                  color : '#d19300 !important'
                }}
            };
            break;
         case SchedulingStatus.called:
            rowConditions = {
               [SchedulingStatus.transit]: {
                  when: row => row.scheduling_status === SchedulingStatus.transit,
                  style:{
                  color : 'green !important'
               }}
            };
            break;

         default:
            rowConditions = {};
            break

      }

      return rowConditions;

  }

  const conditionalRowStyles= (tabIndex) =>{

      const rowConditions = getRowConditionsByTabIndex(tabIndex);

      let rowStyles = Object.keys(rowConditions).map( key => rowConditions[key])

      return rowStyles;
  }

  const clearTimeBlock = () => {
    removeDataStorage('scheduling_timeBlock');
    handleSelectFilterChange(null, 'timeBlock');
  }

  const handleDate = (date) => {
    clearTimeBlock();

    let shouldGetPendings = false;
    if (date !== null) {
      setDataStorage('scheduling_date', date);
      shouldGetPendings = moment(new Date(), 'YYYY-MM-DD').isSame(date, 'day');
      setShowOptionPendings(shouldGetPendings);
      setDataStorage('schedulings_pendings', shouldGetPendings ? 1 : 0);
    } else {
      setShowOptionPendings(false);
      removeDataStorage('scheduling_date');
      removeDataStorage('schedulings_pendings');
      removeDataStorage('scheduling_branches');
      removeDataStorage('scheduling_client');
      removeDataStorage('scheduling_plants');
    }

    handleSelectFilterDate(date, shouldGetPendings ? 1 : 0);
  };

  const showButtonCall = useCallback(() => {
    if (!schedulingPermissions.canCall)
      return false;

    if ('enable_called' in (item?.branch_config || {})) {
      return item.branch_config.enable_called;
    }

    return enableCalled;
  }, [item, enableCalled, schedulingPermissions.canCall]);

  const showButtonCallAgain = useCallback(() => {
    if (!schedulingPermissions.canCall)
      return false;

    if ('enable_called' in (item?.branch_config || {})) {
      return item.branch_config.enable_called;
    }

    return enableCalled;
  }, [item, enableCalled, schedulingPermissions.canCall]);

  const showButtonSend = useCallback(() => {
    if (!schedulingPermissions.canSend)
      return false;

    if ('enable_send_truck' in (item?.branch_config || {})) {
      return item.branch_config.enable_send_truck;
    }

    return enableSendTruck;
  }, [item, enableSendTruck, schedulingPermissions.canSend]);

  return (
    <>
      <div className={classes.TabNavigationCtrlFilterPanel}>
        <Grid container spacing={3}>
          <Grid item md={2} xs={12}>
            <div>
              <DateSelector
                selected={filterDate()}
                placeholder='Filtrar por Data'
                onChange={(date) => handleDate(date)}
                id={"scheduling-page-date-selector-filter"}
                data-cy={"scheduling-page-date-selector-filter-cy"}
              />
            </div>
            {showOptionPendings && (
              <div>
                <Checkbox
                  data-cy={"scheduling-page-pending-scheduling-checkbox-cy"}
                  defaultChecked={!!getDataStorage('schedulings_pendings')}
                  onChange={(event) => {
                    const checked = event.target.checked;
                    setDataStorage('schedulings_pendings', checked ? 1 : 0);
                    handleSelectFilterChange(checked ? 1 : 0, 'shouldGetPendings');
                  }}
                  id="schedulingsPendings"
                  color="primary"
                />
                <label htmlFor="schedulingsPendings">
                  <strong>Mostrar agendamentos pendentes</strong>
                </label>
              </div>
            )}
          </Grid>
          <Grid item md={3} xs={12}>
            <Selector
              id={"scheduling-page-branch-selector-filter"}
              data-cy={"scheduling-page-branch-selector-filter-cy"}
              options={branches}
              isMulti={true}
              width='100%'
              placeholder='Filtrar por filial'
              isDisabled={!getDataStorage('scheduling_date')}
              search
              value={filterInputValue('scheduling_branches')}
              onChange={(selectedBranch) => {
                if (selectedBranch !== null) {
                  setDataStorage('scheduling_branches', selectedBranch)
                } else {
                  removeDataStorage('scheduling_plants');
                  removeDataStorage('scheduling_client');
                  removeDataStorage('scheduling_branches');
                }

                const branches = selectedBranch ? selectedBranch.map(item => item.value) : [];
                handleSelectFilterChange(branches, 'branches');
              }}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <Selector
              id={"scheduling-page-plant-selector-filter"}
              data-cy={"scheduling-page-plant-selector-filter-cy"}
              isDisabled={!getDataStorage('scheduling_branches') || !getDataStorage('scheduling_date')}
              options={plants}
              isMulti={true}
              width='100%'
              placeholder='Filtrar por Planta'
              search
              value={getDataStorage('scheduling_plants')}
              onChange={(selectedPlant) => {
                if (selectedPlant !== null) {
                  setDataStorage('scheduling_plants', selectedPlant);
                } else {
                  removeDataStorage('scheduling_plants');
                }

                const plants = selectedPlant ? selectedPlant.map(item => item.value) : [];
                handleSelectFilterChange(plants, 'plants');
              }}
            />
          </Grid>
          <Grid item md={2} xs={12}>
            <Selector
              id={"scheduling-page-client-selector-filter"}
              data-cy={"scheduling-page-client-selector-filter-cy"}
              options={clients}
              width='100%'
              value={getDataStorage('scheduling_client')}
              selected={getDataStorage('scheduling_client')?.value}
              placeholder='Cliente/Fornecedor'
              search
              isClearable
              isDisabled={!getDataStorage('scheduling_branches') || !getDataStorage('scheduling_date') || !getDataStorage('scheduling_plants')}
              onChange={client => {
                if (client !== null) {
                  setDataStorage('scheduling_client', client);
                } else {
                  removeDataStorage('scheduling_client');
                }
                handleSelectFilterChange(client, 'client');
              }}
            />
          </Grid>
          <Grid item md={2} xs={12}>
            <TextField
              id={"scheduling-page-plate-selector-filter"}
              data-cy={"scheduling-plate-client-selector-filter-cy"}
              placeholder='Filtrar por placa do caminhão'
              size="small"
              className={classes.inputFilterTruckPlate}
              value={filterInputValue('scheduling_inputFilterTruckPlate')}
              onChange={(event) => {
                setDataStorage('scheduling_inputFilterTruckPlate', event?.currentTarget?.value?.replace(/\s/g, ''))
                handleSearchTruckPlate(event?.currentTarget?.value?.replace(/\s/g, ''))
              }}
              variant="outlined"
              InputProps={
               {
                 endAdornment: (
                   <InputAdornment position="end" >
                     <IconButton
                       aria-label="barcode clear"
                       onClick={() => {
                        removeDataStorage('scheduling_inputFilterTruckPlate');
                        handleSearchTruckPlate(null);
                       }}
                       edge="end"
                     >
                      {filterInputValue('scheduling_inputFilterTruckPlate').length > 0 && <IconClear />}
                     </IconButton>
                   </InputAdornment>
                 )
               }
             }
            />
          </Grid>
        </Grid>
        <div className={classes.navigation}>
          <Grid container spacing={3}>
            <Grid item md={enableCalled ? 6 : 8} xs={12}>
              <div>
                <Tabs
                  TabIndicatorProps={{
                    style: {
                      height: '6px',
                      backgroundColor: '#658D1B',
                    }
                  }}
                  className={classes.navigationRoutesTabs}
                  value={currentTab}
                  variant="scrollable"
                  scrollButtons="auto"
                  onChange={handleChangeTab}>
                  {subRoutes.map((route, index) => (
                    <Tab
                      className={classes.navigationRoutesTabsTab}
                      key={index}
                      label={`${route.title} (${schedulings[index]?.length ?? 0})`}
                      {...a11yProps(index)} />
                  ))}
                </Tabs>
              </div>
            </Grid>

            {schedulingPermissions.canCheckin && (
              // @todo: hide on mobile
              <Grid item md={2} xs={12}>
                <div className={classes.navigationControls}>
                  <Button
                    color='primary'
                    variant='contained'
                    size='large'
                    className={classes.addButton}
                    onClick={() => setOpenModalBarcode(true)}
                  >
                    Ler Código de Barras
                  </Button>
                </div>
              </Grid>
            )}
            {/* TODO: REMOVE FALSE  */}
            {false && enableCalled && (
              <Grid item md={2} xs={12}>
                {schedulingPermissions.canCall && (
                  <div >
                    <Button
                      color='primary'
                      variant='contained'
                      size='large'
                      className={classes.calledButton}
                      disabled={!isTabMatchSchedulingStatus(currentTab, SchedulingStatus.inLine) || filterInputValue('scheduling_branches').length === 0 || !schedulings[currentTab]}
                      onClick={() => setOpenModalCalled(true)}
                    >
                      Chamar agendamentos
                    </Button>
                  </div>
                )}
              </Grid>
            )}

            <Grid item md={2} xs={12}>
              {schedulingPermissions.canCreate && (
                <div>
                  <Button
                    color='primary'
                    variant='contained'
                    size='large'
                    className={classes.addButton}
                    onClick={onNewScheduling}
                  >
                    Criar Agendamento
                  </Button>
                </div>
              )}
            </Grid>
          </Grid>

        </div>
        <div>
          <DefaultDataTable
            columns={handleWithTabsAndTitles(schedulingTableColumns, currentTab)}
            data={handleWithColumnAndValues(schedulings[currentTab], currentTab)}
            noDataMessage={noDataMessage()}
            conditionalRowStyles={conditionalRowStyles(currentTab)}
          />
        </div>
      </div>
      <Popover
        open={!!targetPopover}
        anchorEl={targetPopover}
        handleClose={handlePopoverClose}
        handlePrintPDF={handlePrintPDF}
        handleCancel={() => handleOpenConfirm('cancel')}
        handleTransit={() => handleOpenConfirm('transit')}
        handleEdit={() => handleOpenEdit()}
        handleMonitorOpen={() => handleMonitorOpen()}
        cantCancell={cantCancell}
        showButtonCall={showButtonCall}
        showButtonCallAgain={showButtonCallAgain}
        showButtonSend={showButtonSend}
        handleRescheduling={handleRescheduling}
        cantCall={cantCall}
        cantCallAgain={cantCallAgain}
        canEdit={canEdit}
        canRescheduling={canRescheduling}
        canShowRescheduling={canShowRescheduling}
        cantTransit={cantTransit}
      />
      <ModalBarcode
        open={isOpenModalBarcode}
        onClose={() => setOpenModalBarcode(false)}
        onSearch={searchBarcode}
        scheduling={barcodeScheduling}
        onConfirm={onConfirmBarcode}
        setAdditionalInfoCalled={setAdditionalInfoCalled}
        enableCalled={enableCalled}
      />
      <ModalCalled
        open={isOpenModalCalled}
        branches={filterInputValue('scheduling_branches')}
        onConfirm={onCallSeveralScheduling}
        onClose={() => setOpenModalCalled(false)}
      />
      {renderConfirm(modalConfirm[currentModal])}
      <ModalEdit
        getDriver={getDriver}
        editedData={editItem} open={!!editItem}
        handleClose={() => setEditItem(null)}
        handleUpdate={onUpdateScheduling}
      />
    </>
  );
};

SchedulingComponent.propTypes = {
  subRoutes: PropTypes.array.isRequired,
  branches: PropTypes.array.isRequired,
  plants: PropTypes.array.isRequired,
  filter: PropTypes.object.isRequired,
  setTab: PropTypes.func.isRequired,
  currentTab: PropTypes.number.isRequired,
  schedulings: PropTypes.array.isRequired,
  setFilter: PropTypes.func.isRequired,
  onNewScheduling: PropTypes.func.isRequired,
  onViewScheduling: PropTypes.func.isRequired,
  onCancelScheduling: PropTypes.func.isRequired,
  onUpdateScheduling: PropTypes.func.isRequired,
  setDriverCheckin: PropTypes.func,
  setAdditionalInfoCalled: PropTypes.func,
  getDriver: PropTypes.func.isRequired,
  enableCalled: PropTypes.bool.isRequired,
};

export default SchedulingComponent;
